import React from 'react';
// import { useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';

// import { getNewTripRequest } from 'modules/common/CommonTrip/actions';
import importSvg from 'modules/kiosk/containers/Landing/assets/import.svg';
import exportSvg from 'modules/kiosk/containers/Landing/assets/export.svg';
import { useImageOnLoad } from 'modules/shared/hooks';
import { useHistory } from 'react-router-dom';
import styles from './BtnTripTypes.module.scss';

type Props = {
  disabled?: boolean;
  areActive?: boolean;
};

export const BtnTripTypes: React.FC<Props> = ({ disabled, areActive }) => {
  // const dispatch = useDispatch();
  const { handleImageOnLoad, css } = useImageOnLoad();
  const history = useHistory();

  const onCreateTripClick = (tripIntent: number) => {
    // dispatch(getNewTripRequest(tripIntent));

    history.push(`/kiosk/trip/new/${tripIntent}`);
  };

  return (
    <div className={styles.toogle_group}>
      {!disabled && (
        <>
          <Button
            variant="outline-litgth"
            className={styles.type_checkbox}
            onClick={() => onCreateTripClick(2)}
            disabled={!areActive}
          >
            <Form.Label className="mb-0 ml-0 d-flex align-items-center pr-3">
              <img src={importSvg} alt="Розвантаження" onLoad={handleImageOnLoad} style={{ ...css.fullSize }} />
              Розвантаження
            </Form.Label>
          </Button>
          <Button
            variant="outline-litgth"
            className={styles.type_checkbox}
            onClick={() => onCreateTripClick(1)}
            disabled={!areActive}
          >
            <Form.Label className="mb-0 ml-0 d-flex align-items-center pr-3" htmlFor="type-2">
              <img src={exportSvg} alt="Завантаження" onLoad={handleImageOnLoad} style={{ ...css.fullSize }} />
              Завантаження
            </Form.Label>
          </Button>
        </>
      )}
    </div>
  );
};
